import { useEffect, useState } from "react";
import axios from "axios";
const API_BASE_URL = `${process.env.REACT_APP_API_DOMAIN_BACKEND}/api/data`;

export function GetLightpointData(id) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/${id}`);
        setData(response.data?.lightpoint_data || []);
      } catch (err) {
        console.error("Error fetching lightpoint data:", err);
        setError(err);
        setData([]);
      }
    };

    if (id) fetchData();
  }, [id]);

  return { data, error };
}


export function GetAllData(id) {
  const [lightpointData, setLightpointData] = useState(null);
  const [formData, setFormData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/${id}`);
        const data = response.data || {};
        setLightpointData(data.lightpoint_data || []);
        setFormData(data.form_data || {});
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err);
        setLightpointData([]);
        setFormData({});
      }
    };

    fetchData();
  }, [id]);

  return { lightpointData, formData, error };
}



export function GetFormData(id) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/${id}`);
        setData(response.data?.form_data || []);
      } catch (err) {
        console.error("Error fetching form data:", err);
        setError(err);
        setData([]);
      }
    };

    if (id) fetchData();
  }, [id]);

  return { data, error };
}